import * as React from "react";
const SvgFiRrPortalEnter = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-portal-enter_svg__a)">
      <path
        fill="#062147"
        d="M24 12c0 3.608-.292 12-3 12-.628 0-2.298 0-2.861-7.929a1 1 0 1 1 1.995-.142c.206 2.903.58 4.587.871 5.452.458-1.38.995-4.548.995-9.381s-.541-8.022-1-9.395C20.541 3.977 20 7.15 20 12a1 1 0 0 1-1 1h-2.37a3.02 3.02 0 0 1-2.57-1.453l-1.069-1.776-1.285 3.133a1 1 0 0 1-1.851-.76l1.693-4.126A1 1 0 0 0 11.36 8H9.616l-2.065 5.033a1 1 0 0 0 .392 1.225l4.59 2.896c.29.184.466.503.466.846v5a1 1 0 1 1-2 0v-4.448l-4.125-2.604a3 3 0 0 1-1.173-3.675L7.454 8H6.236a.99.99 0 0 0-.894.553l-1.447 2.895a1 1 0 0 1-1.789-.895l1.447-2.895A2.99 2.99 0 0 1 6.236 6h5.124c1.046 0 2.031.557 2.57 1.453l1.844 3.062c.18.299.508.484.856.484h1.377c.059-3.955.512-11 2.993-11 2.708 0 3 8.392 3 12zM5.875 16.814a1 1 0 0 0-1.3.557 1 1 0 0 1-.929.629H1a1 1 0 1 0 0 2h2.646c1.233 0 2.327-.74 2.785-1.885a1 1 0 0 0-.556-1.301M13 5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-portal-enter_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPortalEnter;
